import type { ProfileMeSurvey, ProfileMeSurveyPresent } from '@/api/types';

export type SurveyStepNumber = 1 | 2 | 3 | 4 | 5;

export type SurveyProgressFields = Pick<
  ProfileMeSurveyPresent,
  'step1_basic' | 'step2_lifestyle' | 'step3_symptoms' | 'step4_history' | 'step5_medications'
>;

export function firstIncompleteStepNumber(
  survey: SurveyProgressFields,
): SurveyStepNumber | null {
  if (survey.step1_basic === null) return 1;
  if (survey.step2_lifestyle === null) return 2;
  if (survey.step3_symptoms === null) return 3;
  if (survey.step4_history === null) return 4;
  if (survey.step5_medications === null) return 5;

  return null;
}

export function resumeStepFromSurvey(survey: ProfileMeSurvey): SurveyStepNumber {
  if (!survey.exists) return 1;

  // All step objects exist but profile still says completed=false only for legacy
  // or inconsistent rows; backend c5.1 treats an explicit empty step 5 as complete.
  return firstIncompleteStepNumber(survey) ?? 5;
}
